// extracted by mini-css-extract-plugin
export default {"section_seperator":"SectionSeparator_section_seperator__Ffc4M"};